import { initializeApp } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js";
import { 
  getFirestore, doc, getDoc, setDoc, 
  query, where, getDocs, collection,
  serverTimestamp
} from "https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js";
import { getStorage, ref, uploadBytes, getDownloadURL } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-storage.js";

const firebaseConfig = {
  apiKey: "AIzaSyA2UxM1a1Muy7PquZPP3pc6QyU4PAXwjF0",
  authDomain: "furnihunter-community-jp.firebaseapp.com",
  projectId: "furnihunter-community-jp",
  storageBucket: "furnihunter-community-jp.firebasestorage.app",
  messagingSenderId: "573529217034",
  appId: "1:573529217034:web:c6d6a407e49d06e1ce27f3",
  measurementId: "G-LEMD9XJJNB"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

// 🚨 HTML에서 설정한 글로벌 데이터 받아오기
const currentUserId = window.profileEditData.userId;

let cropper = null, croppedBlob = null;
let isNickChecked = false; 
let lastCheckedNick = ""; 
const DEFAULT_AVATAR = "https://cdn.shopify.com/s/files/1/0656/5127/3993/files/user-placeholder.png?v=1700000000";
let isImageDeleted = false;

const FORBIDDEN_WORDS = [
  "管理者", "運営", "運営者", "スタッフ", "事務局", "担当者", 
  "admin", "administrator", "staff", "support", "system", "manager",
  "furnihunter", "furni", "hunter", "퍼니헌터", 
  "死ね", "ころす", "殺す", "クソ", "カス", "ゴミ", "キチガイ", "糞", "バカ", "馬鹿", "あほ",
  "fuck", "shit", "bitch", "asshole", "bastard", "dick", "pussy", "cunt", "nigger",
  "エロ", "セフレ", "エッチ", "セックス", "変態", "露出", "痴漢", "AV",
  "sex", "porn", "nude", "ero", "hentai",
  "あらし", "荒らし", "広告", "稼げる", "副業", "spam", "ad", "promo"
];

window.checkNicknameDup = async function() {
  const nickInput = document.getElementById('inpNickname');
  const nick = nickInput.value.trim();
  const statusMsg = document.getElementById('nickStatus');

  if (!nick || nick.length < 3) {
    statusMsg.innerText = "ニックネームは2文字以上で入力してください。";
    statusMsg.style.color = "#ed4956";
    return;
  }

  const hasForbidden = FORBIDDEN_WORDS.some(word => nick.toLowerCase().includes(word.toLowerCase()));
  if (hasForbidden) {
    statusMsg.innerText = "使用できない単語が含まれています。";
    statusMsg.style.color = "#ed4956";
    return;
  }

  try {
    const q = query(collection(db, "users"), where("nickname", "==", nick));
    const querySnapshot = await getDocs(q);
    
    let isDuplicate = false;
    querySnapshot.forEach((doc) => {
      if (doc.id !== currentUserId) {
        isDuplicate = true;
      }
    });

    if (isDuplicate) {
      statusMsg.innerText = "このニックネームは既に使用されています。";
      statusMsg.style.color = "#ed4956";
      isNickChecked = false;
    } else {
      statusMsg.innerText = "使用可能なニックネームです。";
      statusMsg.style.color = "#4caf50";
      isNickChecked = true;
      lastCheckedNick = nick;
    }
  } catch (e) {
    console.error(e);
    alert("重複チェック中にエラーが発生しました。");
  }
};

window.addEventListener('load', () => {
  const nickInput = document.getElementById('inpNickname');
  if(nickInput) {
    nickInput.oninput = () => {
      isNickChecked = false;
      document.getElementById('nickStatus').innerText = '';
    };
  }
});

window.addEventListener('load', async () => {
  if(!currentUserId) return;
  
  const today = new Date(); today.setDate(today.getDate() - 1);
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const inpBirth = document.getElementById('inpBirth');
  if(inpBirth) inpBirth.max = `${yyyy}-${mm}-${dd}`;

  try {
    const docRef = doc(db, "users", currentUserId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      if(data.nickname) {
        document.getElementById('inpNickname').value = data.nickname;
        isNickChecked = true;
        lastCheckedNick = data.nickname;
      }
      if(data.bio) document.getElementById('inpBio').value = data.bio;
      if(data.instagramId) document.getElementById('inpInsta').value = data.instagramId;
      if(data.avatarUrl) document.getElementById('previewImg').src = data.avatarUrl;
      if(data.gender) document.getElementById('selGender').value = data.gender;
      if(data.birthDate) document.getElementById('inpBirth').value = data.birthDate;
    }
  } catch(e) { console.error(e); }
});

// --- 크로퍼 관련 함수 ---
window.openCropper = function(input) {
  if (input.files && input.files[0]) {
    const reader = new FileReader();
    reader.onload = function(e) {
      const img = document.getElementById('cropperImage'); img.src = e.target.result;
      document.getElementById('cropModal').style.display = 'flex';
      if(cropper) cropper.destroy();
      cropper = new Cropper(img, { aspectRatio: 1, viewMode: 1, dragMode: 'move', autoCropArea: 1, responsive: true });
    }
    reader.readAsDataURL(input.files[0]);
  }
  input.value = ""; 
}
window.closeCropper = function() { document.getElementById('cropModal').style.display = 'none'; if(cropper) cropper.destroy(); }
window.applyCrop = function() {
  if(!cropper) return;
  const canvas = cropper.getCroppedCanvas({ width: 300, height: 300 }); 
  document.getElementById('previewImg').src = canvas.toDataURL();
  canvas.toBlob(function(blob) { croppedBlob = blob; closeCropper(); }, 'image/jpeg', 0.9);
}

window.removeProfileImg = function() {
  if (confirm("プロフィール写真を削除して初期状態に戻しますか？")) {
    document.getElementById('previewImg').src = DEFAULT_AVATAR;
    croppedBlob = null; 
    isImageDeleted = true; 
  }
};

window.saveProfile = async function() {
  if(!currentUserId) {
    alert("ログインが必要です。");
    return;
  }

  const nickInput = document.getElementById('inpNickname');
  const nick = nickInput.value.trim();

  if (!isNickChecked || nick !== lastCheckedNick) {
    alert("ニックネームの重複確認を行ってください。"); 
    return;
  }

  const btn = document.getElementById('btnSave');
  btn.innerText = "保存中..."; 
  btn.classList.add('fh-btn-disabled');
  btn.disabled = true;

  try {
    const userRef = doc(db, "users", currentUserId);
    const userSnap = await getDoc(userRef);
    const userData = userSnap.exists() ? userSnap.data() : {};

    let shouldUpdateNickDate = false;
    
    if (userData.nickname && userData.nickname !== nick) {
        if (userData.nickUpdatedAt) {
            const lastTime = new Date(userData.nickUpdatedAt).getTime();
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTime;
            const diffDays = diffTime / (1000 * 60 * 60 * 24); 

            if (diffDays < 14) {
                const remainDays = Math.ceil(14 - diffDays);
                alert(`ニックネームは14日に1回のみ変更可能です。\nあと${remainDays}日お待ちください。`);
                
                btn.innerText = "保存する (Save)"; 
                btn.classList.remove('fh-btn-disabled');
                btn.disabled = false;
                return; 
            }
        }
        shouldUpdateNickDate = true;
    } else if (!userData.nickname) {
        shouldUpdateNickDate = true;
    }

    let avatarUrl = document.getElementById('previewImg').src;

    if (croppedBlob) {
      const storageRef = ref(storage, `profiles/${currentUserId}/avatar.jpg`);
      await uploadBytes(storageRef, croppedBlob);
      avatarUrl = await getDownloadURL(storageRef);
    } else if (isImageDeleted || avatarUrl.includes('user-placeholder.png')) {
      const firstChar = nick.charAt(0).toUpperCase();
      avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(firstChar)}&background=random&color=fff&size=300&rounded=true`;
    }

    const updateData = {
      nickname: nick,
      bio: document.getElementById('inpBio').value.trim(), 
      instagramId: document.getElementById('inpInsta').value.trim(), 
      avatarUrl: avatarUrl,
      gender: document.getElementById('selGender').value, 
      birthDate: document.getElementById('inpBirth').value, 
      updatedAt: new Date().toISOString()
    };

    if (shouldUpdateNickDate) {
        updateData.nickUpdatedAt = new Date().toISOString();
    }

    await setDoc(userRef, updateData, { merge: true });

    alert("プロフィールが保存されました！");
    location.href = "/pages/community_mypage"; 

  } catch(e) {
    console.error(e);
    alert("エラーが発生しました。");
    btn.innerText = "保存する (Save)"; 
    btn.classList.remove('fh-btn-disabled');
    btn.disabled = false;
  }
};